module.exports = [
  "$locationProvider",
  "$stateProvider",
  "$urlRouterProvider",
  function($locationProvider, $stateProvider, $urlRouterProvider) {
    window
      .getRoutingHelper($stateProvider)
      .state("news", {
        url: "/news",
        params: createApp({
          name: "news",
          title: "News",
          otherwise: "/news"
        }),
        views: {
          "": {
            template: require("./views/shared/news.html"),
            controller: "NewsCtrl as News"
          }
        },
        animation: {
          enter: "fade-view",
          start: "fade-view"
        }
      })
      // .state('news.feed', {
      //   url: '/newsfeed',
      //   views: {
      //     '': {
      //       controller: 'NewsfeedCtrl as Newsfeed',
      //       templateProvider: [function () {
      //         if (window.isMobile) {
      //           return require('./views/mobile/feed.html');
      //         } else {
      //           return require('./views/desktop/feed.html');
      //         }
      //       }]
      //     },
      //     'header': {
      //       template: require('./views/shared/header.html')
      //     }
      //   },
      //   animation: {
      //     enter: 'fade-view',
      //     start: 'fade-view'
      //   }
      // })
      .state("news.article", {
        url: "/article:{articleId}",
        params: {
          articleId: ""
        },
        views: {
          "": {
            template: require("./views/shared/article.html"),
            controller: "ArticleCtrl as Article"
          },
          "header@news": {
            template: require("./views/shared/header-article.html")
          }
        },
        animation: function() {
          if (window.isDesktop) {
            return {
              start: "fade-view",
              replace: "fade-view",
              enter: "fade-view",
              leave: "fade-view"
            };
          } else {
            return {
              start: "fade-view",
              replace: "fade-view",
              enter: "detail",
              leave: "detail"
            };
          }
        }
      });

    function createApp($app, def) {
      var app = def || {};
      Object.defineProperty(app, "$app", {
        enumerable: true,
        value: $app
      });
      return app;
    }
  }
];



// WEBPACK FOOTER //
// ./src/apps/news/routes.js